import {CHANGE_STEP} from './constants'

export const changeStep = (step) => {
    return (
        dispatch
    ) => {
        dispatch({
            type:CHANGE_STEP, 
            payload: step
        })
    }

}

export function reducer(state, action) {
    if(action.type === CHANGE_STEP){
            return{
                ...state, 
                policies:{...state.policies,
                        currentStep:{
                                    ...state.currentStep, 
                                    order:action.payload
                        }
                }
            }
    }
    else {
        return state
    }
}